// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qU-q","label":"styles_label__13-_w"};